import query from '@/components/query/query-constructor';
import { replaceReportRoute, reportRouteParams } from '@/components/query/report-route-query';
import { useReportParams } from '@/composables/useReportParams';
import type { PickUrlContext } from '@/views/reports/pickers/base/utils';

export const pushURL = (ctx: PickUrlContext, cb?: () => void) => {
  const savedColumnsInCurentPreset = useReportParams().savedColumnsInCurentPreset.value;
  if (ctx.$route.name !== 'app.postbacks' || !savedColumnsInCurentPreset) return;

  const {
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset,
    postbackStatus,
  } = ctx.getTableQueryForCurrentTab() as Record<string, unknown>;

  const { columns, order, context } = savedColumnsInCurentPreset.postbacks;
  const data = query.get({
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset: (offset as Record<string, number>)[context],
    ...order,
    columns,
    postbackStatus,
    groupBy: context,
  });

  replaceReportRoute(ctx.$router, {
    name: 'app.postbacks',
    params: {
      data: data,
      report: ctx.$route.params.report,
      ...reportRouteParams({ manual: true, picker: true }),
    },
  }, cb);
};
